import { motion } from "framer-motion";
import { PACKAGES } from "@/data/content";
import { SectionHead } from "@/components/landing/Categories";
import { Check } from "lucide-react";
import { PhonePeQr } from "@/components/landing/PhonePeQr";

export const Packages = ({ onRegister, onProof }) => (
  <section id="packages" className="relative py-24 px-5 sm:px-8 bg-[#121216]">
    <div className="max-w-7xl mx-auto">
      <SectionHead
        eyebrow="Registration & Pricing"
        title="Nomination Packages"
        sub="Transparent pricing for awardees, JFC nominees, stay & tour add-ons and accompanying members."
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {PACKAGES.map((p, i) => (
          <motion.div
            key={p.tier}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className="card-lux rounded-2xl p-7 flex flex-col"
            data-testid={`package-${i}`}
          >
            <span className="font-mono-lux text-[10px] tracking-[0.2em] text-amber-400 uppercase">
              {p.badge}
            </span>
            <h3 className="font-serif-lux text-xl text-amber-50 mt-3">{p.tier}</h3>
            <div className="font-display text-2xl gold-text font-700 mt-4">{p.fee}</div>
            <p className="text-sm text-zinc-400 mt-4 leading-relaxed flex-1">{p.desc}</p>
          </motion.div>
        ))}
      </div>
      <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-6 p-8 rounded-2xl bg-[#18181F] gold-border">
        <div className="flex items-start gap-3 text-sm text-zinc-300 max-w-2xl">
          <Check className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" />
          <span>
            One accompanying member is included free. Additional members are $50 each for the
            ceremony, and $50 per person if they also opt for the Stay & Tour.
          </span>
        </div>
        <button
          onClick={onRegister}
          className="gold-gradient-bg text-black font-700 px-8 py-3.5 rounded-full hover:brightness-110 transition-all whitespace-nowrap"
          data-testid="packages-register-button"
        >
          Start Registration
        </button>
      </div>
      <div
        className="mt-8 grid md:grid-cols-[1fr_auto] items-center gap-8 p-8 rounded-2xl card-lux"
        data-testid="payment-section"
      >
        <div>
          <span className="font-mono-lux text-[10px] tracking-[0.2em] text-amber-400 uppercase">
            Payment
          </span>
          <h3 className="font-display text-2xl gold-text font-700 mt-3">Pay Securely via PhonePe</h3>
          <p className="text-sm text-zinc-400 mt-4 leading-relaxed max-w-xl">
            Scan the QR code with PhonePe, Google Pay, Paytm or any UPI app to pay your registration,
            extra member or Stay & Tour fees to <span className="text-amber-100">MRG Group of Companies</span>.
            Share the transaction ID with our team to get your registration confirmed.
          </p>
          <button
            onClick={onProof}
            className="mt-6 px-6 py-3 rounded-full gold-border text-amber-300 hover:bg-amber-500/10 text-sm font-600 transition-colors"
            data-testid="packages-submit-proof-button"
          >
            Already paid? Submit payment proof
          </button>
        </div>
        <PhonePeQr compact />
      </div>
    </div>
  </section>
);
